import React from 'react';
import Icon from '../../../components/AppIcon';


const WrittenReviewCard = ({ review }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        color={index < rating ? "#FFD700" : "#E5E5E7"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  const handleShare = () => {
    const message = `Read this amazing review from ${review?.name} about Nitin Online Hub! "${review?.content?.substring(0, 100)}..." Join this trusted gaming platform today!`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="bg-card rounded-card shadow-subtle hover:shadow-royal transition-royal p-6 border border-border">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center">
            <Icon name="User" size={20} color="white" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-text-primary">{review?.name}</h3>
            <p className="text-sm text-text-secondary">{review?.location}</p>
          </div>
        </div>
        
        {/* Platform Badge */}
        <div className="flex items-center space-x-1 bg-muted px-2 py-1 rounded text-xs font-medium">
          <Icon name={review?.platform === 'google' ? 'Search' : 'Facebook'} size={12} />
          <span className="capitalize">{review?.platform}</span>
        </div>
      </div>
      {/* Rating */}
      <div className="flex items-center space-x-2 mb-4">
        <div className="flex space-x-1">
          {renderStars(review?.rating)}
        </div>
        <span className="text-sm font-medium text-text-primary">{review?.rating}/5</span>
        <span className="text-sm text-text-secondary">• {review?.date}</span>
      </div>
      {/* Review Content */}
      <blockquote className="text-text-primary leading-relaxed mb-4">
        "{review?.content}"
      </blockquote>
      {/* Highlights */}
      {review?.highlights && review?.highlights?.length > 0 && (
        <div className="mb-4">
          <div className="flex flex-wrap gap-2">
            {review?.highlights?.map((highlight, index) => (
              <span
                key={index}
                className="bg-primary/10 text-primary px-2 py-1 rounded-full text-xs font-medium"
              >
                {highlight}
              </span>
            ))}
          </div>
        </div>
      )}
      {/* Footer */}
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-4 text-sm text-text-secondary">
          <div className="flex items-center space-x-1">
            <Icon name="ThumbsUp" size={14} />
            <span>{review?.likes} helpful</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="MessageCircle" size={14} />
            <span>Verified Player</span>
          </div>
        </div>
        
        <button
          onClick={handleShare}
          className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-royal"
        >
          <Icon name="Share" size={14} />
          <span className="text-sm font-medium">Share</span>
        </button>
      </div>
    </div>
  );
};

export default WrittenReviewCard;